import { Box, Typography, styled } from '@mui/material';

import { FONT_FAMILY } from '@/shared/ui/form-fields/fieldStyles';

export const ServiceCardsRow = styled(Box)({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(0, 1fr)',
  gap: '0.5rem',
  padding: '0.5rem 0',
});

export const ServiceCard = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  minWidth: 0,
  padding: '0.5rem 1rem',
  borderRadius: '0.8125rem',
  border: `1px solid ${selected ? theme.palette.blue[500] : theme.palette.grey[200]}`,
  backgroundColor: selected ? theme.palette.blue[100] : theme.palette.common.white,
  cursor: 'pointer',
  textAlign: 'left',
  font: 'inherit',
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  '&:hover:not(:disabled)': selected
    ? {}
    : { borderColor: theme.palette.blue[500], backgroundColor: theme.palette.blue[50] },
  '&:disabled': { cursor: 'default', opacity: 0.6 },
}));

export const ServiceRadio = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  width: '1.125rem',
  height: '1.125rem',
  borderRadius: '50%',
  flexShrink: 0,
  boxSizing: 'border-box',
  border: selected
    ? `5px solid ${theme.palette.blue[500]}`
    : `1px solid ${theme.palette.blue[300]}`,
  backgroundColor: theme.palette.common.white,
}));

export const ServiceTitle = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 350,
  lineHeight: '130%',
  letterSpacing: 0,
  color: theme.palette.grey[950],
}));

export const ServiceSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 350,
  lineHeight: '125%',
  letterSpacing: 0,
  color: theme.palette.grey[400],
}));
